import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import Home from './pages/Home'
import Destinations from './pages/Destinations'
import SafariExperiences from './pages/SafariExperiences'
import ExperienceDetail from './pages/ExperienceDetail'
import Activities from './pages/Activities'
import About from './pages/About'
import Contact from './pages/Contact'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import PlantingGreenPaths from './pages/PlantingGreenPaths'
import PlanYourTrip from './pages/PlanYourTrip'
import BwindiImpenetrable from './pages/BwindiImpenetrable'
import KibaleNationalPark from './pages/KibaleNationalPark'
import QueenElizabeth from './pages/QueenElizabeth'
import MurchisonFalls from './pages/MurchisonFalls'
import KidepoValley from './pages/KidepoValley'
import LakeMburo from './pages/LakeMburo'
import MountElgon from './pages/MountElgon'
import RwenzoriMountains from './pages/RwenzoriMountains'
import SemulikiValley from './pages/SemulikiValley'
import LakeBunyonyi from './pages/LakeBunyonyi'
import Jinja from './pages/Jinja'
import MgahingaGorilla from './pages/MgahingaGorilla'
import DestinationDetail from './pages/DestinationDetail'
import PackageDetail from './pages/PackageDetail'
import GorillaTrekking from './pages/activities/GorillaTrekking.jsx'
import WhitewaterRafting from './pages/activities/WhitewaterRafting.jsx'
import BungeeJumping from './pages/activities/BungeeJumping.jsx'
import ChimpanzeeTrekking from './pages/activities/ChimpanzeeTrekking.jsx'
import ChimpHabituation from './pages/activities/ChimpHabituation.jsx'
import KazingaBoatSafari from './pages/activities/KazingaBoatSafari.jsx'
import GoldenMonkeyTracking from './pages/activities/GoldenMonkeyTracking.jsx'
import GorillaHabituation from './pages/activities/GorillaHabituation.jsx'
import SipiFallsAbseiling from './pages/activities/SipiFallsAbseiling.jsx'
import HotAirBalloon from './pages/activities/HotAirBalloon.jsx'
import LionTracking from './pages/activities/LionTracking.jsx'
import KayakingAdventures from './pages/activities/KayakingAdventures.jsx'
import QuadBiking from './pages/activities/QuadBiking.jsx'
import HorsebackRidingJinja from './pages/activities/HorsebackRidingJinja.jsx'
import StandUpPaddleboarding from './pages/activities/StandUpPaddleboarding.jsx'
import RiverTubing from './pages/activities/RiverTubing.jsx'
import BatwaTrail from './pages/activities/BatwaTrail.jsx'
import BwindiBirdwatching from './pages/activities/BwindiBirdwatching.jsx'
import BwindiNatureWalks from './pages/activities/BwindiNatureWalks.jsx'
import MountSabinyoClimb from './pages/activities/MountSabinyoClimb.jsx'
import MountGahingaClimb from './pages/activities/MountGahingaClimb.jsx'
import MountMuhavuraClimb from './pages/activities/MountMuhavuraClimb.jsx'
import MgahingaBatwaCulture from './pages/activities/MgahingaBatwaCulture.jsx'
import ChimpKyamburaGorge from './pages/activities/ChimpKyamburaGorge.jsx'
import QueenElizabethGameDrives from './pages/activities/QueenElizabethGameDrives.jsx'
import CraterLakesDrive from './pages/activities/CraterLakesDrive.jsx'
import MountElgonTrekking from './pages/activities/MountElgonTrekking.jsx'
import VirungaVolcanoClimbing from './pages/activities/VirungaVolcanoClimbing.jsx'
import LakeBunyonyiCanoeing from './pages/activities/LakeBunyonyiCanoeing.jsx'
import LakeMburoWalkingSafaris from './pages/activities/LakeMburoWalkingSafaris.jsx'
import LakeMburoHorsebackSafaris from './pages/activities/LakeMburoHorsebackSafaris.jsx'
import SempayaHotSprings from './pages/activities/SempayaHotSprings.jsx'
import MurchisonFallsTopHike from './pages/activities/MurchisonFallsTopHike.jsx'
import MurchisonSportFishing from './pages/activities/MurchisonSportFishing.jsx'
import LakeMburoMountainBiking from './pages/activities/LakeMburoMountainBiking.jsx'
import KidepoGameDrives from './pages/activities/KidepoGameDrives.jsx'
import KaramojongCulturalEncounters from './pages/activities/KaramojongCulturalEncounters.jsx'
import SemulikiNightWalks from './pages/activities/SemulikiNightWalks.jsx'
import SourceOfTheNile from './pages/activities/SourceOfTheNile.jsx'
import SunsetCruise from './pages/activities/SunsetCruise.jsx'
import MountainBikingJinja from './pages/activities/MountainBikingJinja.jsx'
import UgandaSafari17Days from './pages/packages/UgandaSafari17Days'
import WildlifeSafari12Days from './pages/packages/WildlifeSafari12Days'
import GorillaChimp7Days from './pages/packages/GorillaChimp7Days'
import HighlightsSafari8Days from './pages/packages/HighlightsSafari8Days'
import GorillasLions5Days from './pages/packages/GorillasLions5Days'
import BirdingSafari10Days from './pages/packages/BirdingSafari10Days'
import KibaleChimp3Days from './pages/packages/KibaleChimp3Days'
import MurchisonChimp3Days from './pages/packages/MurchisonChimp3Days'
import APITest from './pages/APITest'

function App() {
  return (
    <Router>
      <div className="mobile-min-vh-100 flex flex-col prevent-horizontal-scroll">
        <Navigation />
        <main className="flex-grow prevent-horizontal-scroll">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/destinations/bwindi-impenetrable" element={<BwindiImpenetrable />} />
            <Route path="/destinations/kibale-national-park" element={<KibaleNationalPark />} />
            <Route path="/destinations/queen-elizabeth" element={<QueenElizabeth />} />
            <Route path="/destinations/murchison-falls" element={<MurchisonFalls />} />
            <Route path="/destinations/kidepo-valley" element={<KidepoValley />} />
            <Route path="/destinations/lake-mburo" element={<LakeMburo />} />
            <Route path="/destinations/mount-elgon" element={<MountElgon />} />
            <Route path="/destinations/rwenzori-mountains" element={<RwenzoriMountains />} />
            <Route path="/destinations/semuliki-valley" element={<SemulikiValley />} />
            <Route path="/destinations/lake-bunyonyi" element={<LakeBunyonyi />} />
            <Route path="/destinations/jinja" element={<Jinja />} />
            <Route path="/destinations/mgahinga-gorilla" element={<MgahingaGorilla />} />
            {/* Dynamic route for CMS destinations - must come after specific routes */}
            <Route path="/destinations/:slug" element={<DestinationDetail />} />
            <Route path="/experiences" element={<SafariExperiences />} />
            <Route path="/experiences/:slug" element={<ExperienceDetail />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/activities/gorilla-trekking" element={<GorillaTrekking />} />
            <Route path="/activities/whitewater-rafting" element={<WhitewaterRafting />} />
            <Route path="/activities/bungee-jumping" element={<BungeeJumping />} />
            <Route path="/activities/chimpanzee-trekking" element={<ChimpanzeeTrekking />} />
            <Route path="/activities/chimp-habituation" element={<ChimpHabituation />} />
            <Route path="/activities/kazinga-boat-safari" element={<KazingaBoatSafari />} />
            <Route path="/activities/golden-monkey-tracking" element={<GoldenMonkeyTracking />} />
            <Route path="/activities/gorilla-habituation" element={<GorillaHabituation />} />
            <Route path="/activities/sipi-falls-abseiling" element={<SipiFallsAbseiling />} />
            <Route path="/activities/hot-air-balloon-safari" element={<HotAirBalloon />} />
            <Route path="/activities/lion-tracking" element={<LionTracking />} />
            <Route path="/activities/kayaking-adventures" element={<KayakingAdventures />} />
            <Route path="/activities/quad-biking" element={<QuadBiking />} />
            <Route path="/activities/horseback-riding-jinja" element={<HorsebackRidingJinja />} />
            <Route path="/activities/stand-up-paddleboarding" element={<StandUpPaddleboarding />} />
            <Route path="/activities/river-tubing" element={<RiverTubing />} />
            <Route path="/activities/batwa-trail" element={<BatwaTrail />} />
            <Route path="/activities/bwindi-birdwatching" element={<BwindiBirdwatching />} />
            <Route path="/activities/bwindi-nature-walks" element={<BwindiNatureWalks />} />
            <Route path="/activities/mount-sabinyo-climb" element={<MountSabinyoClimb />} />
            <Route path="/activities/mount-gahinga-climb" element={<MountGahingaClimb />} />
            <Route path="/activities/mount-muhavura-climb" element={<MountMuhavuraClimb />} />
            <Route path="/activities/mgahinga-batwa-culture" element={<MgahingaBatwaCulture />} />
            <Route path="/activities/chimp-kyambura-gorge" element={<ChimpKyamburaGorge />} />
            <Route path="/activities/queen-elizabeth-game-drives" element={<QueenElizabethGameDrives />} />
            <Route path="/activities/crater-lakes-drive" element={<CraterLakesDrive />} />
            <Route path="/activities/mount-elgon-trekking" element={<MountElgonTrekking />} />
            <Route path="/activities/virunga-volcano-climbing" element={<VirungaVolcanoClimbing />} />
            <Route path="/activities/lake-bunyonyi-canoeing" element={<LakeBunyonyiCanoeing />} />
            <Route path="/activities/lake-mburo-walking-safaris" element={<LakeMburoWalkingSafaris />} />
            <Route path="/activities/lake-mburo-horseback-safaris" element={<LakeMburoHorsebackSafaris />} />
            <Route path="/activities/sempaya-hot-springs" element={<SempayaHotSprings />} />
            <Route path="/activities/murchison-falls-hike" element={<MurchisonFallsTopHike />} />
            <Route path="/activities/murchison-sport-fishing" element={<MurchisonSportFishing />} />
            <Route path="/activities/lake-mburo-mountain-biking" element={<LakeMburoMountainBiking />} />
            <Route path="/activities/kidepo-game-drives" element={<KidepoGameDrives />} />
            <Route path="/activities/karamojong-cultural-encounters" element={<KaramojongCulturalEncounters />} />
            <Route path="/activities/semuliki-night-walks" element={<SemulikiNightWalks />} />
            <Route path="/activities/source-of-the-nile" element={<SourceOfTheNile />} />
            <Route path="/activities/sunset-cruise" element={<SunsetCruise />} />
            <Route path="/activities/mountain-biking-jinja" element={<MountainBikingJinja />} />
            <Route path="/packages/17-days-ultimate-safari" element={<UgandaSafari17Days />} />
            <Route path="/packages/12-days-wildlife-safari" element={<WildlifeSafari12Days />} />
            <Route path="/packages/7-days-gorilla-chimp-safari" element={<GorillaChimp7Days />} />
            <Route path="/packages/8-days-highlights-safari" element={<HighlightsSafari8Days />} />
            <Route path="/packages/5-days-gorillas-lions" element={<GorillasLions5Days />} />
            <Route path="/packages/10-days-birding-safari" element={<BirdingSafari10Days />} />
            <Route path="/packages/3-days-kibale-chimp-cultural" element={<KibaleChimp3Days />} />
            <Route path="/packages/3-days-murchison-chimp" element={<MurchisonChimp3Days />} />
            {/* Dynamic route for CMS packages - must come after specific routes */}
            <Route path="/packages/:slug" element={<PackageDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/planting-green-paths" element={<PlantingGreenPaths />} />
            <Route path="/plan-your-trip" element={<PlanYourTrip />} />
            <Route path="/api-test" element={<APITest />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
